import { Getter } from "../types";

export default {
  [Getter.IS_AUTHENTICATED]: (state) => !!state.token,
  [Getter.GET_TOKEN]: state => state.token,
};
